import LocationSelect from '@/components/location-select/index.vue';
import Bus from '../../bus.js';

export default {
  components: {
    LocationSelect
  },
  data() {
    return {
      areaCode: '',
      form: {
        householdsType: 1,
        city: '',
        county: '',
        township: '',
        village: '',
        address: ''
      },
      rules: {
        householdsType: [
          { required: true, message: '请选择户口类别', trigger: 'change'}
        ],
        // city: [
        //   { required: true, message: '请选择地址', trigger: 'change'}
        // ],
        village: [
          { required: true, message: '请选择完整的地址', trigger: 'change' }
        ],
        address: [
          { required: true, message: '请输入您的详细地址', trigger: 'blur'}
        ]
      }
    };
  },
  created() {
  },
  watch: {
    'form.householdsType'() {
      Bus.$emit('emit', this.form.householdsType);
    }
  },
  methods: {
    areaCodeChange(event) {
      this.areaCode = event.areaCode;
      const key = event && event.type;
      this.form[key] = event.areaCode;
    },
    validateForm() {
      let isValid = false;
      this.$refs['form'].validate(valid => {
        isValid = valid;
      });
      return isValid;
    }
  }

};
